import axios from 'axios';
import authService from './authService';

const API_URL = '/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class ApiService {
  // Public endpoints
  getPublicInfo() {
    return axios.get(API_URL + 'public/info');
  }

  submitContactForm(contactData) {
    return axios.post(API_URL + 'public/contact', contactData);
  }

  // Blog endpoints
  getBlogPosts() {
    return axios.get(API_URL + 'blog/public/posts');
  }

  getBlogPost(id) {
    return axios.get(API_URL + 'blog/public/posts/' + id);
  }
}

export default new ApiService();